import Question from './Question'

/**
 * Number Group 由很多個要填入數字的問題所組成
 * 資料儲存的方式是一個 Object key-value pair
 *
 * Object {
 *   optionId: amount
 * }
 *
**/
export class NumberGroup extends Question {
  get defaultValue () {
    return this._questionDefinition.defaultValue || {}
  }

  // TODO: use deep-equal
  get isValueDefault () {
    return (Object.keys(this.defaultValue).length === Object.keys(this.value).length &&
      Object.keys(this.value).every(k => this.defaultValue[k] === this.value[k]))
  }

  get optionIds () {
    return this._questionDefinition.options
  }

  get options () {
    return this.optionIds.map(oid => this.cartElementBuilder.buildOption(oid, this.stateObj, this._menu))
  }

  get currentLevelPrice () {
    return parseFloat(this.selectedOptionIds.reduce((sum, oid) =>
      sum +
      this.cartElementBuilder.buildOption(oid, this.stateObj, this._menu).price * this.value[oid], 0))
  }

  get totalPrice () {
    return parseFloat(this.selectedOptionIds.reduce((sum, oid) =>
      sum +
      this.cartElementBuilder.buildOption(oid, this.stateObj, this._menu).totalPrice * this.value[oid], 0))
  }

  get hasValue () { return Object.keys(this.value).length !== 0 }
  get selectedOptions () {
    return this.selectedOptionIds.map(oid => this.cartElementBuilder.buildOption(oid, this.stateObj, this._menu))
  }
  get selectedOptionIds () { return Object.keys(this.value) }
  get activeSubQuestions () {
    return this.selectedOptions.reduce((questions, option) => questions.concat(option.questions), [])
  }
  get valueString () { return this.selectedOptions.map(o => o.title + ' x ' + this.value[o.id]).join(', ') }
  get valueStringWithTitle () {
    if (this.valueString) {
      return this.title + ': ' + this.valueString
    } else {
      return this.title + ': 無'
    }
  }
  get errorMessage () { return '點我選: ' + this.title } // TODO: 之後要加上太多或太少的訊息

  optionAmount (optionId) { return this.value[optionId] || 0 }

  isOptionSelected (optionId) { return !!this.value[optionId] }
}
